import CustomAxios from '@atbay/http-client'
import { envVars } from '@core/environment/env-vars'
import { handleErrorResponse } from './apiResponseCallbacks'

const baseUrl = envVars.REACT_APP_API_BASE_URL
const urlPrefix = envVars.REACT_APP_API_URL_PREFIX

const customAxiosObj = new CustomAxios(baseUrl, urlPrefix, handleErrorResponse)

export default customAxiosObj.axiosInstance
